import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../../Providers/mainStore.slice';
import { LoginSteps } from './login.constants';
import { loginWithPassword } from './login.thunks';

const initialState = {
  step: LoginSteps.ENTER_USER_AND_PASSWORD,
  twoFactorMethods: [],
  twoFactorToken: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetLoginState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetAllSlices, () => initialState)
      .addCase(loginWithPassword.fulfilled, (state, action) => {
        return { ...state, ...action.payload };
      });
  },
});

export const { setLoginState, resetLoginState } = loginSlice.actions;
export default loginSlice.reducer;
